import React from 'react';
import { Heading, FinancingDescription, ButtonWrapper } from '../shared/Financing.styles';
import { GetTermsButton, WhyTermsChange } from './ExpiredFinancing.styles';
import { KissMetrics } from '../../../shared/services';

const ExpiredFinancing = () => (
  <>
    <Heading>Your Terms Have Expired</Heading>
    <FinancingDescription>
      Re-apply to browse thousands of certified vehicles with your real terms without impacting your
      credit score!
    </FinancingDescription>
    <ButtonWrapper>
      <GetTermsButton
        href="/financing-prequalification"
        onClick={() =>
          KissMetrics.trackEvent(
            'Account - Finance - Clicked Get Your Personalized Financing Terms'
          )
        }
      >
        Get Your Personalized Financing Terms
      </GetTermsButton>
    </ButtonWrapper>
    <WhyTermsChange>
      <p>Your terms may change based on any changes in your personal credit history</p>
    </WhyTermsChange>
  </>
);

export default ExpiredFinancing;
